import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, from } from 'rxjs';
import { concatMap, take, filter } from 'rxjs/operators';
import { PlanStatusService } from './plan-status-cache.service';

@Injectable({ providedIn: 'root' })
export class PlanStatusCacheResolver implements Resolve<any> {
  constructor(private planStatusService: PlanStatusService) {}

  resolve(): Observable<any> {
    // Ensure the service has loaded data, then return the current plan statuses
    // Wait for the subject to emit a non-empty list so resolver doesn't return
    // an incomplete (e.g. single-item) snapshot when PJ profiles are still loading.
    return from(this.planStatusService.loadForCurrentUser()).pipe(
      concatMap(() => this.planStatusService.planStatuses$),
      // only continue when the list is non-empty
      filter((list: any[]) => !!list && list.length > 0),
      take(1)
    );
  }
}
